import { QuoteEffects } from './quote.effects';

export const QUOTE_EFFECTS = [QuoteEffects];

export * from './quote.effects';
